import { render, staticRenderFns } from "./SrmSidebar.vue?vue&type=template&id=6fd7a5eb&scoped=true"
import script from "./SrmSidebar.vue?vue&type=script&lang=js"
export * from "./SrmSidebar.vue?vue&type=script&lang=js"
import style0 from "./SrmSidebar.vue?vue&type=style&index=0&id=6fd7a5eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd7a5eb",
  null
  
)

export default component.exports